import { useMemo } from "react";
import { useTranslation } from "react-i18next";
const k = {
    columnDate: "domains.dynamic-invoice.pages.dynamic-invoice-page.components.dynamic-invoice-dialog.components.matter-ledger-entries.matter-ledger-entries-i18n.columnDate",
    columnText: "domains.dynamic-invoice.pages.dynamic-invoice-page.components.dynamic-invoice-dialog.components.matter-ledger-entries.matter-ledger-entries-i18n.columnText",
    columnAmount: "domains.dynamic-invoice.pages.dynamic-invoice-page.components.dynamic-invoice-dialog.components.matter-ledger-entries.matter-ledger-entries-i18n.columnAmount",
    listHeader: "domains.dynamic-invoice.pages.dynamic-invoice-page.components.dynamic-invoice-dialog.components.matter-ledger-entries.matter-ledger-entries-i18n.listHeader"
};
export const translations = {
    da: {
        columnDate: "Dato",
        columnText: "Tekst",
        columnAmount: "Beløb",
        listHeader: "Finansposter"
    },
    en: {
        columnDate: "Date",
        columnText: "Text",
        columnAmount: "Amount",
        listHeader: "General ledger entries"
    }
};
export const useT = () => {
    const { t, i18n } = useTranslation();
    const localT = useMemo(() => ({
        columnDate: t(k.columnDate),
        columnText: t(k.columnText),
        columnAmount: t(k.columnAmount),
        listHeader: t(k.listHeader)
    }), [i18n.language]);
    return useMemo(() => ({ t: localT, i18n }), [localT, i18n]);
};
